import { CSV_BOM, CSV_DELIMITER, csvRow } from "@/lib/csv";

/** Delimitador do CSV de reference data: ";" é o separador de lista do Excel
 *  pt-BR e é o que o parser de ingestão (`ref_ingestion/parsers.py`) espera.
 *  Vírgula é conteúdo comum — células JSON de colunas `jsonb` (ex.: `predicate`)
 *  atravessam o arquivo sem precisar de aspas.
 *
 *  Reexportado do módulo compartilhado (`lib/csv.ts`): a regra de escape é a
 *  mesma do export de custo, e duas cópias dela divergiriam. O nome próprio
 *  fica porque aqui o delimitador é **requisito do parser de ingestão**, não
 *  só conveniência de planilha — quem mexer precisa saber disso. */
export const REF_CSV_DELIMITER = CSV_DELIMITER;

/** Serializa uma linha do CSV de reference data. Pura/testável. */
export function referenceDataCsvRow(cells: string[]): string {
  return csvRow(cells, REF_CSV_DELIMITER);
}

/** Conteúdo do template de upload: só o cabeçalho com as colunas aceitas,
 *  prefixado com BOM UTF-8 pro Excel detectar o encoding (o parser de ingestão
 *  descarta o BOM). Pura/testável. */
export function templateCsv(columns: string[]): string {
  return `${CSV_BOM}${referenceDataCsvRow(columns)}\n`;
}
